import React from "react";

// custom components
import CustomAlert from "../custom-alert";

// constants
import { VERBIAGE_CONSTANTS } from "../../utils/verbiage.constants";

// custom styles
import styles from "./index.module.scss";

// Warning shown on every current-loan page while AURA is running (CX.AUS.RESULT "In Progress").
// All edit actions on the page are disabled until it clears.
const AuraInProgressBanner = ({ show }) => {
	if (!show) return null;
	return (
		<CustomAlert
			severity="warning"
			subject="AURA is running"
			details={VERBIAGE_CONSTANTS.AURA_IN_PROGRESS_BANNER}
			extraClass={styles.banner}
		/>
	);
};

export default AuraInProgressBanner;
